import {createContext} from "react";

export interface SelectionCardContextValue {
  value?: string;
  onChange?: (value: string) => void;
}

export const SelectionCardContext = createContext<SelectionCardContextValue | null>(null);
